import IconTooltip from './IconTooltip';
import SystemIconModifier, { type SystemIconProps } from './SystemIcon';

function Percent(props: SystemIconProps) {
  const { isSystem } = props;
  return (
    <IconTooltip isSystem={isSystem}>
      <svg
        className="MuiSvgIcon-root MuiSvgIcon-fontSizeMedium fs-exclude"
        focusable="false"
        aria-hidden="true"
        data-testid="PercentIcon"
        data-dd-action-name="FIM 3 Custom Field - icon redacted"
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect width="28" height="28" rx="4" fill="#C0E6CB" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.4497 7.55051C20.1605 7.26051 19.6913 7.26051 19.4022 7.55051L7.55051 19.4022C7.40551 19.5472 7.33301 19.7363 7.33301 19.9263C7.33301 20.1155 7.40551 20.3055 7.55051 20.4497C7.83967 20.7388 8.30801 20.7388 8.59801 20.4497L20.4497 8.59801C20.7388 8.30801 20.7388 7.83967 20.4497 7.55051ZM17.3333 19.8333C16.6441 19.8333 16.0833 19.2724 16.0833 18.5833C16.0833 17.8941 16.6441 17.3333 17.3333 17.3333C18.0224 17.3333 18.5833 17.8941 18.5833 18.5833C18.5833 19.2724 18.0224 19.8333 17.3333 19.8333ZM17.3333 15.6666C15.7249 15.6666 14.4166 16.9749 14.4166 18.5833C14.4166 20.1916 15.7249 21.4999 17.3333 21.4999C18.9416 21.4999 20.2499 20.1916 20.2499 18.5833C20.2499 16.9749 18.9416 15.6666 17.3333 15.6666ZM10.6666 8.99992C11.3558 8.99992 11.9166 9.56076 11.9166 10.2499C11.9166 10.9391 11.3558 11.4999 10.6666 11.4999C9.97742 11.4999 9.41659 10.9391 9.41659 10.2499C9.41659 9.56076 9.97742 8.99992 10.6666 8.99992ZM10.6666 13.1666C12.2749 13.1666 13.5833 11.8583 13.5833 10.2499C13.5833 8.64159 12.2749 7.33326 10.6666 7.33326C9.05826 7.33326 7.74992 8.64159 7.74992 10.2499C7.74992 11.8583 9.05826 13.1666 10.6666 13.1666Z"
          fill="#539868"
        />
        <mask
          id="mask0_2984_257343"
          //   style="mask-type:luminance"
          maskUnits="userSpaceOnUse"
          x="7"
          y="7"
          width="14"
          height="15"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M20.4497 7.55051C20.1605 7.26051 19.6913 7.26051 19.4022 7.55051L7.55051 19.4022C7.40551 19.5472 7.33301 19.7363 7.33301 19.9263C7.33301 20.1155 7.40551 20.3055 7.55051 20.4497C7.83967 20.7388 8.30801 20.7388 8.59801 20.4497L20.4497 8.59801C20.7388 8.30801 20.7388 7.83967 20.4497 7.55051ZM17.3333 19.8333C16.6441 19.8333 16.0833 19.2724 16.0833 18.5833C16.0833 17.8941 16.6441 17.3333 17.3333 17.3333C18.0224 17.3333 18.5833 17.8941 18.5833 18.5833C18.5833 19.2724 18.0224 19.8333 17.3333 19.8333ZM17.3333 15.6666C15.7249 15.6666 14.4166 16.9749 14.4166 18.5833C14.4166 20.1916 15.7249 21.4999 17.3333 21.4999C18.9416 21.4999 20.2499 20.1916 20.2499 18.5833C20.2499 16.9749 18.9416 15.6666 17.3333 15.6666ZM10.6666 8.99992C11.3558 8.99992 11.9166 9.56076 11.9166 10.2499C11.9166 10.9391 11.3558 11.4999 10.6666 11.4999C9.97742 11.4999 9.41659 10.9391 9.41659 10.2499C9.41659 9.56076 9.97742 8.99992 10.6666 8.99992ZM10.6666 13.1666C12.2749 13.1666 13.5833 11.8583 13.5833 10.2499C13.5833 8.64159 12.2749 7.33326 10.6666 7.33326C9.05826 7.33326 7.74992 8.64159 7.74992 10.2499C7.74992 11.8583 9.05826 13.1666 10.6666 13.1666Z"
            fill="white"
          />
        </mask>
        <g mask="url(#mask0_2984_257343)"></g>
        {isSystem && SystemIconModifier()}
      </svg>
    </IconTooltip>
  );
}

export default Percent;
